import { User } from 'src/interfaces/users';
import apiStoresBOBFF from 'src/config/api/apiStoreBFF';
import { SOURCE_BO, USERS_PATH } from 'src/services/utils';


const findMe = async () => {
  const url = `${USERS_PATH}/me?source=${SOURCE_BO}`;
  const response = await apiStoresBOBFF.get<User>(url);
  return response.data;
};


const usersServices = {
    findMe,
};

export default usersServices;
